const actions = {
  SET_STATE: "account/SET_STATE",
  LOGIN: "account/LOGIN",
  LOGOUT: "account/LOGOUT",
};

export default actions;
